module.exports = __webpack_public_path__ + "static/media/event4.60d58ffe.jpg";